// extracted by mini-css-extract-plugin
module.exports = {"blank-story":"tnc6s","story-heading":"_1Lo1l","blank-story-author":"_3QnWU","published-time":"_3I_X1","blank-story-hero-image-wrapper":"_3hbGi","blank-story-hero-image":"iJZWf"};